import ViewListaSprawozdan from "../../components/views/sprawozdania/oper/listaSprawozdan/ViewListaSprawozdan.jsx";
import ViewSprawozdanieForm from "../../components/views/sprawozdania/oper/sprawozdanieForm/ViewSprawozdanieForm.jsx";

export const sprawozdaniaRoutes = [
    {
        path: `/oper/sprawozdanie/lista/:rejestrId`,
        exact: true,
        roles: [`rejestr_podglad`],
        forbidden: true,
        view: <ViewListaSprawozdan />,
        mode: `any`,
    },
    {
        path: `/oper/sprawozdanie/podglad/:rejestrId/:sprawozdanieId`,
        exact: true,
        roles: [`rejestr_podglad`],
        forbidden: true,
        view: <ViewSprawozdanieForm />,
        mode: `any`,
    },
    {
        path: `/oper/sprawozdanie/podglad/:rejestrId`,
        exact: true,
        roles: [`rejestr_podglad`],
        forbidden: true,
        view: <ViewSprawozdanieForm />,
        mode: `any`,
    },
    {
        path: `/oper/sprawozdanie/edycja/:rejestrId/:sprawozdanieId`,
        exact: true,
        roles: [`rejestr_modyfikacja`],
        forbidden: true,
        view: <ViewSprawozdanieForm />,
        mode: `any`,
    },
    {
        path: `/oper/sprawozdanie/edycja/:rejestrId`,
        exact: true,
        roles: [`rejestr_modyfikacja`],
        forbidden: true,
        view: <ViewSprawozdanieForm />,
        mode: `any`,
    },
]
